import React from 'react';
 
class WhoWeAre extends React.Component {
    render(){
        return (
            <section className="who-we-are ptb-80 bg-f6f6f6">
                <div className="container">
                    <div className="section-title">
                        <h2>Quiénes <span>Somos</span></h2>
                        <p>Somos un grupo de profesionales aplicados a los negocios internacionales que se desenvuelven efectivamente en diversas áreas.</p>
                    </div>
                    
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="single-who-we-are">
                                <i className="fa fa-users"></i>
                                <h4>Somos Profesionales</h4>
                                <p>Contamos con un equipo de trabajo capacitado y con amplia experiencia.</p>
                                <span>1</span>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div className="single-who-we-are">
                                <i className="fa fa-lightbulb-o"></i>
                                <h4>Somos Comprometidos</h4>
                                <p>Sentimos pasión por lo que hacemos y damos nuestro mejor esfuerzo en cada caso.</p>
                                <span>2</span>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div className="single-who-we-are">
                                <i className="fa fa-tag"></i>
                                <h4>Somos Integros</h4>
                                <p>Nuestro equipo es una familia que se rige por los mas elevados valores morales y éticos.</p>
                                <span>3</span>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div className="single-who-we-are">
                                <i className="fa fa-scissors"></i>
                                <h4>Somos Efectivos</h4>
                                <p>Entendemos que nuestra clientele requiere de resultados eficáces y nos esforzamos en ello.</p>
                                <span>4</span>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div className="single-who-we-are">
                                <i className="fa fa-linode"></i>
                                <h4>Somos Multidisciplinarios</h4>
                                <p>Nuestro equipo cuenta con experiencia en temas de leyes, negociación y procedimientos.</p>
                                <span>5</span>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div className="single-who-we-are">
                                <i className="fa fa-life-ring"></i>
                                <h4>Somos Visionarios</h4>
                                <p>En nuestros colaboradores encontrará un equipo con una amplia visión del mundo entero.</p>
                                <span>6</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default WhoWeAre;